import Swiper, { A11y, Mousewheel, Navigation, Pagination } from 'swiper';
import { debounce } from 'debounce';
import { docReady } from '../utils/docReady';
Swiper.use([Mousewheel, Navigation, A11y, Pagination]);
const sectionSelectors = {
    carousel: '[data-multi-col-carousel]',
    nextElem: '.multi-col-carousel__slide--next',
    prevElem: '.multi-col-carousel__slide--prev',
};
class Carousel {
    constructor(container, slidesPerView, swiperNext, swiperPrev) {
        this.swiper = null;
        this.slidesPerView = 0;
        // Best window width max values to add the swiper. This values are also in the tiles.scss.
        // 706px/16px;
        this.carouselBreakpoint = 48;
        this.addSwiper = () => {
            if (!this.swiper) {
                this.swiper = new Swiper(this.swiperContainer, {
                    navigation: {
                        nextEl: sectionSelectors.nextElem,
                        prevEl: sectionSelectors.prevElem,
                    },
                    slidesPerView: this.slidesPerView,
                });
            }
        };
        this.destroySwiper = () => {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        };
        this.swiperContainer = container;
        this.slidesPerView = slidesPerView;
        this.nextElement = swiperNext;
        this.prevElement = swiperPrev;
        const onWindowResize = debounce(() => {
            const widthInEms = window.innerWidth / 16;
            let showSwiper = false;
            if (this.carouselBreakpoint <= widthInEms) {
                showSwiper = true;
            }
            if (showSwiper) {
                this.addSwiper();
            }
            else {
                this.destroySwiper();
            }
        }, 200);
        onWindowResize();
        window.addEventListener('resize', onWindowResize);
    }
}
const initCarousel = () => {
    const multiColCarousels = document.querySelectorAll(sectionSelectors.carousel);
    if (multiColCarousels) {
        [...multiColCarousels].forEach((carousel) => {
            const slidesPerView = Number(carousel.dataset.slidesPerView);
            const swiperNext = sectionSelectors.nextElem;
            const swiperPrev = sectionSelectors.prevElem;
            const carouselElem = new Carousel(carousel, slidesPerView, swiperNext, swiperPrev);
        });
    }
};
docReady(initCarousel());
